<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
      <h1>CENTRE REFERRAL</h1>
    </div>
  </b-container>
</template>

<script>

export default {
  title: "Center Referral",
  name: "Referral",
  components: {
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
h1 {
 margin-top: 50px;
}
</style>